export const reminderOptions = [
  {
    value: 'emailMe',
    label: 'Email',
    name: 'reminderEmail'
  },
  {
    value: 'callMe',
    label: 'Call',
    name: 'reminderCall'
  },
  {
    value: 'directMailMe',
    label: 'Direct mail',
    name: 'reminderDirectMail'
  }
]

export const promotionOptions = [
  {
    value: 'emailMe',
    label: 'Email',
    name: 'promotionEmail'
  },
  {
    value: 'callMe',
    label: 'Call',
    name: 'promotionCall'
  },
  {
    value: 'directMailMe',
    label: 'Direct mail',
    name: 'promotionDirectMail'
  }
]

export default {
  reminders: {
    name: 'reminders',
    defaultData: reminderOptions
  },
  promotions: {
    name: 'promotions',
    defaultData: promotionOptions
  }
}
